export enum LoyaltyProgramsTypesEnum {
  CashBack = 1,
  Points = 2,
  Crypto = 3,
}
